import ReportDownloadContainer from '@app/components/reports/components/report-download-container';
import useGeneratePdf from '@app/components/reports/hooks/use-generate-pdf';
import { OperationReportTypeEnum } from '@shared/api/types';
import { useParams } from 'react-router-dom';
import { usePurchaseReportResult } from './purchase-report-result-context';
import { usePurchaseReportSections } from './purchase-report-sections';
import { usePurchaseFormattedReportSections } from './purchase-report-utils';
import PurchaseReportIntro from './sections/purchase-report-intro';

export default function PurchaseReportDownload() {
  const { report_uuid } = useParams();
  const { result, resultStatus } = usePurchaseReportResult();
  const { contentRef, status: downloadStatus } = useGeneratePdf(
    result ? result.title : undefined
  );

  const reportSections = usePurchaseReportSections(result, report_uuid!);
  const data = usePurchaseFormattedReportSections(reportSections, result);

  return (
    <ReportDownloadContainer
      contentRef={contentRef}
      status={resultStatus}
      sections={data}
      Intro={PurchaseReportIntro}
      reportType={OperationReportTypeEnum.purchase}
      downloadStatus={downloadStatus}
    />
  );
}
